import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-teal-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-10 md:mb-12">
          {/* Brand */}
          <div className="space-y-5 md:space-y-8">
            <h2 className="text-4xl md:text-6xl font-bold">{t('footer.brand')}</h2>
            <p className="text-white/80 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex gap-4 md:gap-6">
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-amber-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-amber-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-amber-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-book-line text-base md:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 md:w-10 md:h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-amber-400 hover:text-amber-400 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-base md:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6 md:space-y-8">
            <div>
              <h3 className="text-xs uppercase tracking-wider mb-2 md:mb-3 text-white/60">{t('footer.address')}</h3>
              <p className="text-sm md:text-base">{t('footer.addressLine1')}</p>
            </div>
            <div>
              <h3 className="text-xs uppercase tracking-wider mb-2 md:mb-3 text-white/60">{t('footer.phone')}</h3>
              <p className="text-sm md:text-base">{t('footer.phoneNumber')}</p>
            </div>
          </div>

          {/* Image - hidden on mobile */}
          <div className="hidden md:flex justify-end">
            <div className="w-48 h-64 rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/e3ae046d7cc183f87011e25e396f16c5.jpg"
                alt="Healing Space"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-6 md:pt-8 border-t border-amber-400/20">
          <div className="flex flex-col gap-3 md:flex-row md:justify-between md:items-center">
            <p className="text-xs md:text-sm text-white/70">{t('footer.copyright')}</p>
            <div className="flex gap-5 md:gap-8">
              <a href="#" className="text-xs md:text-sm text-white/70 hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap">
                {t('footer.privacy')}
              </a>
              <a href="#" className="text-xs md:text-sm text-white/70 hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap">
                {t('footer.terms')}
              </a>
              <a href="#" className="text-xs md:text-sm text-white/70 hover:text-amber-400 transition-colors cursor-pointer whitespace-nowrap">
                {t('footer.sitemap')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
